import React from 'react';
import parse from 'html-react-parser';

import { ModalContainer, Spinner } from '@welbe/web-design-system';

import {
	Container,
	Content,
	SpinnerContent,
	Preview,
} from './ModalPreviewEmailCommunication.styles';

import { useModalPreviewEmailCommunication } from './ModalPreviewEmailCommunication.hooks';
import { ErrorInfo } from 'App/Components/ErrorInfo/ErrorInfo';

type ModalPreviewEmailCommunicationProps = {
	onClose: () => void;
	campaign: {
		id: string;
		communication: {
			type: string;
			message: string;
			useCustomTemplate: boolean;
		};
	};
};

export const ModalPreviewEmailCommunication = ({
	onClose,
	campaign,
}: ModalPreviewEmailCommunicationProps): JSX.Element => {
	const { isLoading, preview } = useModalPreviewEmailCommunication({
		campaign,
	});

	return (
		<ModalContainer
			visible
			zIndex={1400}
			hasCloseButton
			closeOnlyOnTheButton
			onClose={onClose}
			height={'80vh'}
			width={'750px'}
		>
			<Container>
				<Content>
					{isLoading ? (
						<SpinnerContent>
							<Spinner size="40px" />
						</SpinnerContent>
					) : (
						<>
							{campaign.communication.type && (
								<Preview>{preview ? parse(preview) : <ErrorInfo />}</Preview>
							)}
						</>
					)}
				</Content>
			</Container>
		</ModalContainer>
	);
};
